// src/portal/contexts/illustrations/components/BookLibrary/components/EmptyLibrary.tsx

'use client';

import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { BookOpen, Plus } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';

interface EmptyLibraryProps {
  hasFilter: boolean;
}

export function EmptyLibrary({ hasFilter }: EmptyLibraryProps) {
  const t = useTranslations('illustrations.library.empty');

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center" data-testid="illustration-library-empty">
      <div className="mb-4 rounded-full bg-muted p-6">
        <BookOpen className="h-12 w-12 text-muted-foreground" />
      </div>
      <h2 className="mb-2 text-lg font-semibold">
        {hasFilter ? t('filteredTitle') : t('title')}
      </h2>
      <p className="mb-6 max-w-md text-muted-foreground">
        {hasFilter ? t('filteredDescription') : t('description')}
      </p>
      {!hasFilter && (
        <Button asChild size="lg" data-testid="illustration-library-create-first-button">
          <Link href="/create?job=hero">
            <Plus className="h-4 w-4" />
            {t('createFirst')}
          </Link>
        </Button>
      )}
    </div>
  );
}
